<template>
  <div class="order-modal-flights-container">
    <h4>{{ $t("פרטי הטיסה") }}</h4>

    <div class="order-modal-flights">
      <div class="flight-from">
        <div class="flight-head">
          <span>{{ $t("הלוך") }}</span>
          <div class="flight-logo">
            <img :src="airlineLogo(flights[0])" />
          </div>
        </div>
        <div class="flight-details">
          {{ moment(flights[0].date).format("DD/MM/YYYY") }}
          | {{ $t("טיסה") }} {{ flights[0].airline_number }}
        </div>
        <div class="flight-plan">
          <div class="flight-origin">
            <div class="icon icon-takeoff"></div>
            <div class="flight-time">
              {{ flights[0].depart_hour }}
              <div class="flight-city">
                {{ flights[0].airport_name }}
              </div>
            </div>
          </div>
          <div class="flight-line"></div>
          <div class="flight-destination">
            <div class="icon icon-landing"></div>
            <div class="flight-time">
              {{ flights[0].arrive_hour }}
              <div class="flight-city">
                {{ flights[1].airport_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flight-to">
        <div class="flight-head">
          <span>{{ $t("חזור") }}</span>
          <div class="flight-logo">
            <img :src="airlineLogo(flights[1])" />
          </div>
        </div>
        <div class="flight-details">
          {{ moment(flights[1].date).format("DD/MM/YYYY") }}
          | {{ $t("טיסה") }} {{ flights[1].airline_number }}
        </div>
        <div class="flight-plan">
          <div class="flight-origin">
            <div class="icon icon-takeoff"></div>
            <div class="flight-time">
              {{ flights[1].depart_hour }}
              <div class="flight-city">
                {{ flights[1].airport_name }}
              </div>
            </div>
          </div>
          <div class="flight-line"></div>
          <div class="flight-destination">
            <div class="icon icon-landing"></div>
            <div class="flight-time">
              {{ flights[1].arrive_hour }}
              <div class="flight-city">
                {{ flights[0].airport_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["airlineLogo", "flights"],

  computed: {
    moment: () => moment,
  },
};
</script>

<style lang="scss" scoped>
.order-modal-flights {
  border-radius: 8px;
  background-image: radial-gradient(circle at 50% 0, #dfe1e8, #ebecf3 111%);
  padding: 24px 58px 30px 58px;
  display: flex;
  width: 100%;
  max-width: 100%;

  @media screen and (max-width: 991px) {
    flex-wrap: wrap;
    background: none;
    padding: 24px 35px 30px 35px;
  }

  .flight-from,
  .flight-to {
    flex-basis: 50%;

    @media screen and (max-width: 991px) {
      flex-basis: 100%;
    }
  }

  .flight-from {
    padding-left: 60px;
    border-left: solid 1px rgba(151, 151, 151, 0.2046);

    @media screen and (max-width: 991px) {
      padding-left: 0;
      border-left: none;
      border-bottom: solid 1px rgba(151, 151, 151, 0.3);
      padding-bottom: 40px;
      margin-bottom: 20px;
    }
  }

  .flight-to {
    padding-right: 60px;

    @media screen and (max-width: 991px) {
      padding-right: 0;
    }
  }

  .flight-head {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    color: rgba(57, 57, 57, 0.57);

    .flight-logo {
      max-width: 80px;
      height: 28px;
      font-size: 0;
      line-height: 0;
    }
  }

  .flight-details {
    font-size: 16px;
    font-weight: bold;
    color: #2f3a4c;
    margin: 5px 0;
  }

  .flight-plan {
    display: flex;
    align-items: center;

    .flight-origin,
    .flight-destination {
      display: flex;
      align-items: center;
      position: relative;

      .icon {
        position: absolute;
      }
    }

    .flight-origin {
      .icon {
        right: -30px;
      }
    }

    .flight-destination {
      .icon {
        left: -30px;
      }
    }

    .flight-time {
      font-size: 22px;
      font-weight: 600;
      color: #000000;
      position: relative;

      .flight-city {
        margin-top: 2px;
        font-weight: normal;
        position: absolute;
        font-size: 12px;
        text-align: right;
        color: #4a4a4a;
        white-space: nowrap;
      }
    }

    .flight-line {
      flex-grow: 1;
      border-bottom: solid 1px #2f3a4c;
      position: relative;
      margin: 0 35px;

      &::before,
      &::after {
        position: absolute;
        display: block;
        content: "";
        border: solid 1px #2f3a4c;
        border-radius: 50%;
        width: 6px;
        height: 6px;
        top: 50%;
        transform: translateY(-50%);
      }

      &::before {
        left: -6px;
      }

      &::after {
        right: -6px;
      }
    }
  }
}

.order-modal-flights-container {
  @media screen and (max-width: 991px) {
    padding: 65px 18px 18px 18px;
  }

  h4 {
    display: none;
    color: #201a2d;
    font-size: 19px;
    font-weight: 900;
    text-align: center;
    margin-bottom: 30px;

    @media screen and (max-width: 991px) {
      display: block;
    }
  }
}
</style>